module.exports = __webpack_public_path__ + "img/barcode.ebff1de9.svg";